import React from "react";
import { ArrowRight, Check } from "lucide-react";
import "./login.css";

const STANDARD = ["Tutte le funzioni del gestionale", "Look Blu ingego sui documenti", "Filigrana ingego",
  "Timbro e firma dello studio", "Riga ingego a piè di pagina"];
const PRO = ["Sei palette colore per i documenti", "Colori proposti dal logo dello studio", "Ritocco manuale dei colori",
  "Logo dello studio su ogni documento", "Filigrana personalizzata", "Nessun riferimento ingego nei documenti"];

export default function PricingPage() {
  return <main className="legal-page pricing" data-testid="pricing-page">
    <img src="/brand/ingego-logo.png" alt="ingego" />
    <h1>Un gestionale, due modi di firmare i tuoi documenti</h1>
    <p>ingego organizza pratiche, cantieri, scadenze, preventivi ed economico del tuo studio. Tutte le funzioni operative
      sono incluse: cambia solo quanto i documenti generati parlano con il tuo brand.</p>

    <div className="pricing-grid">
      <section className="pricing-card" data-testid="pricing-standard">
        <p className="eyebrow">Standard</p>
        <h2>Gratis</h2>
        <small>Per iniziare subito, senza carta di credito.</small>
        <ul>{STANDARD.map(row => <li key={row}><Check size={14} />{row}</li>)}</ul>
      </section>
      <section className="pricing-card featured" data-testid="pricing-pro">
        <p className="eyebrow">Pro</p>
        <h2>50 € <span>una volta</span></h2>
        <small>Pagamento unico, nessun abbonamento. IVA calcolata al pagamento dove dovuta.</small>
        <ul>{PRO.map(row => <li key={row}><Check size={14} />{row}</li>)}</ul>
        <a className="pricing-cta" href="/" data-testid="pricing-cta">Accedi e sblocca Pro <ArrowRight size={15} /></a>
        <small>Lo sblocco si attiva da Impostazioni → Colori documenti con l'account amministratore dello studio.</small>
      </section>
    </div>

    <h2>Come funziona la prova</h2>
    <p>Ogni nuovo studio parte con <b>14 giorni di Pro incluso</b>: personalizzi colori, logo e filigrana e vedi come
      escono i tuoi documenti. Alla fine della prova, senza fare nulla, il gestionale torna al piano Standard e i
      documenti riprendono il look ingego: nessun addebito automatico.</p>

    <a className="legal-back" href="/" data-testid="pricing-back">Torna all'accesso</a>
  </main>;
}
